import useCoreModelsFind from '../../../../hooks/useCoreModelsFind'

export default function useUser(id, opts) {
  return useCoreModelsFind('user', id, opts)
}
